import React, { PureComponent } from 'react';
import { IMAGES_REPO } from '../../../config';
import Dates from '../date';

export default class SectionTypeInitialText extends PureComponent {

  render() {
    const { showImages = true, showDates = true, is_soon = false, body, image, title, sub_title, start_date, end_date } = this.props;

    return (
      <div className="initial-text">
        <div className="initial-text__title"><h2>{title}</h2> {sub_title && !is_soon && <h3>{sub_title}</h3>}</div>
        {
          showDates && !is_soon && <Dates start={start_date} end={end_date}/>
        }
        <div className="more-about-us">
          {
            showImages && !is_soon && <div className="more-about-us__images">
              {image && <img className="img" src={`${IMAGES_REPO}${image}`}/>}
            </div>
          }
          <div dangerouslySetInnerHTML={{ __html: body }}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/type-of-sections/initial-text/index.js